import * as yup from "yup"
import { TipologiaImmagine } from "../../types"

export function initialValuesTipologiaImmagine(tipologia?: TipologiaImmagine | undefined) {
  if (tipologia) {
    return tipologia
  }
  return {
    nome: "",
    nome_plurale: "",
    descrizione: "",
    mostra_in_cipec: false,
  }
}

export function validationSchemaTipologiaImmagine() {
  return yup.object().shape({
    nome: yup.string().required("Campo obbligatorio"),
  })
}
